import { useState } from "react";
import { faqList } from "@/mocks/baoliao";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number>(0);
  return (
    <section id="faq" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-2xl">
          <p className="text-xs text-primary-600 font-medium tracking-widest uppercase">FAQ</p>
          <h2 className="mt-1 text-2xl md:text-3xl text-foreground-950">关于吃瓜，你可能想问</h2>
        </div>

        <div className="mt-8 max-w-3xl flex flex-col gap-3">
          {faqList.map((faq, idx) => {
            const open = openIdx === idx;
            return (
              <div
                key={faq.q}
                className="rounded-xl border border-background-200/70 bg-background-100 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : idx)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-[15px] font-medium text-foreground-950">{faq.q}</span>
                  <span
                    className={`inline-flex w-7 h-7 shrink-0 items-center justify-center rounded-full bg-background-200 text-foreground-700 transition-transform duration-300 ${
                      open ? "rotate-45 bg-primary-100 text-primary-700" : ""
                    }`}
                  >
                    <i className="ri-add-line" />
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-4 animate-rise-in">
                    <p className="text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}